import moment from 'moment';
import {createSelector} from 'reselect';

import type {NutshellState} from '../../store';

export const getSidebarState = (state: NutshellState) => state.ui.sidebar;

export const getSidebarCalendarActiveView = (state: NutshellState) => {
    return getSidebarState(state).activeView;
};

export const getSidebarCalendarDisplayDate = (state: NutshellState) => {
    return getSidebarState(state).displayDate;
};

export const getSidebarCalendarMomentDisplayDate = createSelector(
    [getSidebarCalendarDisplayDate],
    (displayDate) => {
        return moment(displayDate);
    }
);
